import React, { Component } from 'react'

const defaultButton = props => (
  <a className="btn btn-default" {...props}>{props.children}</a>
)

export default class Pagination extends Component {
  constructor(props) {
    super()

    this.getSafePage = this.getSafePage.bind(this)
    this.changePage = this.changePage.bind(this)
    this.applyPage = this.applyPage.bind(this)
    this.handleSearch = _.debounce(this.handleSearch, 500)

    this.state = {
      page: props.page,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ page: nextProps.page, search: nextProps.search })
  }

  getSafePage(page) {
    if (Number.isNaN(page)) {
      page = this.props.page
    }
    return Math.min(Math.max(page, 0), this.props.pages - 1)
  }

  changePage(page) {
    page = this.getSafePage(page)
    this.setState({ page })
    if (this.props.page !== page) {
      this.props.onPageChange(page)
    }
  }

  applyPage(e) {
    if (e) {
      e.preventDefault()
    }
    const page = this.state.page
    this.changePage(page === '' ? this.props.page : page)
  }

  handleSearch(search) {
    this.setState({ search: search }, () => {
      if (this.props.onSearchChange) {
        this.props.onSearchChange(this.state.search);
      }
    })
  }

  render() {
    const {
      // Computed
      pages,
      // Props
      page,
      search,
      showPageSizeOptions,
      pageSizeOptions,
      pageSize,
      canPrevious,
      canNext,
      onPageSizeChange,
      PreviousComponent = defaultButton,
      NextComponent = defaultButton,
    } = this.props

    const uniqueRef = _.uniqueId('pagination_');

    return (
      <div className="telemetry-pagination">
        <div className="row pagination-header">
          <div className="col-sm-7 pagination-search">
            <div className="input-group add-on">
              <input ref={uniqueRef} value={search} className="form-control" onChange={() => this.handleSearch(this.refs[uniqueRef].value)} placeholder="Search" name="srch-term" id="srch-term" type="text" />
              <div className="input-group-btn">
                <button className="btn btn-default" type="submit"><i className="glyphicon glyphicon-search"></i></button>
              </div>
            </div>
          </div>
          <div className="col-sm-5 pagination-items-per-page">
            {showPageSizeOptions && (
              <select onChange={e => onPageSizeChange(Number(e.target.value))} value={pageSize} className="form-control">
                {pageSizeOptions.map((option, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <option key={i} value={option}>
                    {`${option} ${this.props.rowsText}`}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
        <div className="row pagination-footer">
          <div className="col-sm-5 pagination-info">
            {this.props.pageText}{' '}
            <span className="-currentPage">{page + 1}</span>{' '}
            {this.props.ofText} <span className="-totalPages">{pages ? pages.toLocaleString() : 1 || 1}</span>
          </div>
          <div className="col-sm-7 pagination-buttons">
            <div className="btn-group">
              <PreviousComponent
                onClick={() => {
                  if (!canPrevious) return
                  this.changePage(page - 1)
                }}
                disabled={!canPrevious}>
                &laquo; {this.props.previousText}
              </PreviousComponent>
              <NextComponent
                onClick={() => {
                  if (!canNext) return
                  this.changePage(page + 1)
                }}
                disabled={!canNext}>
                {this.props.nextText} &raquo;
                            </NextComponent>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Pagination.js